import React from 'react';
import { ThemeContextProvider } from '@qler-view/shared_lib/src/shared/lib/providers/ThemeProviderContext.tsx';
import { facilityLightTheme, facilityDarkTheme } from '../utils/facilityTheme';
import type { ReactNode } from 'react';

interface FacilityThemeProviderProps {
  children: ReactNode;
}

export const FacilityThemeProvider: React.FC<FacilityThemeProviderProps> = ({
  children,
}) => {
  return (
    <ThemeContextProvider
      lightTheme={facilityLightTheme}
      darkTheme={facilityDarkTheme}
    >
      {children}
    </ThemeContextProvider>
  );
};
